import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'extender-tag',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './extender-tag.component.html',
  styleUrls: ['./extender-tag.component.scss', '../../common/scss/route-itinerary-common.scss'],
})
export class ExtenderTagComponent {
  constructor() {}
}
